import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LocalizeParser, LocalizeRouterModule, LocalizeRouterSettings } from '@gilsdav/ngx-translate-router';
import { LocalizeRouterHttpLoader } from '@gilsdav/ngx-translate-router-http-loader';
import { TranslateService } from '@ngx-translate/core';

import { AgenciesComponent } from './content/agencies/agencies.component';
import { BlogComponent } from './content/blogs/blog/blog.component';
import { BlogsComponent } from './content/blogs/blogs.component';
import { ClientComponent } from './content/client/client.component';
import { HomeComponent } from './content/home/home.component';
import { JobComponent } from './content/jobs/job/job.component';
import { JobsComponent } from './content/jobs/jobs.component';
import { LabsComponent } from './content/labs/labs.component';
import { OfferComponent } from './content/offers/offer/offer.component';
import { OffersComponent } from './content/offers/offers.component';
import { ShowcaseComponent } from './content/showcases/showcase/showcase.component';
import { ShowcasesComponent } from './content/showcases/showcases.component';
import { SpiritComponent } from './content/spirit/spirit.component';
import { TeamComponent } from './content/teams/team/team.component';
import { TeamsComponent } from './content/teams/teams.component';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function HttpLoaderFactory(
  translate: TranslateService,
  location: Location,
  settings: LocalizeRouterSettings,
  http: HttpClient
): LocalizeRouterHttpLoader {
  return new LocalizeRouterHttpLoader(translate, location, settings, http);
}

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'offers',
    component: OffersComponent,
  },
  {
    path: 'offers/:slug',
    component: OfferComponent,
  },
  {
    path: 'spirit',
    component: SpiritComponent,
  },
  {
    path: 'team',
    component: TeamsComponent,
  },
  {
    path: 'team/:slug',
    component: TeamComponent,
  },
  {
    path: 'client',
    component: ClientComponent,
  },
  {
    path: 'jobs',
    component: JobsComponent,
  },
  {
    path: 'jobs/:slug',
    component: JobComponent,
  },
  {
    path: 'agencies',
    component: AgenciesComponent,
  },
  {
    path: 'showcase',
    component: ShowcasesComponent,
  },
  {
    path: 'showcase/:slug',
    component: ShowcaseComponent,
  },
  {
    path: 'blog',
    component: BlogsComponent,
  },
  {
    path: 'blog/:slug',
    component: BlogComponent,
  },
  {
    path: 'labs',
    component: LabsComponent,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      initialNavigation: 'disabled',
      anchorScrolling: 'enabled',
    }),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: HttpLoaderFactory,
        deps: [TranslateService, Location, LocalizeRouterSettings, HttpClient],
      },
      initialNavigation: true,
    }),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class AppRoutingModule {}
